import React from "react";

import { Props } from "./types";

function MenuIcon({ className }: Props) {
  return (
    <svg
      className={className}
      enable-background="new 0 0 515.555 515.555"
      viewBox="0 0 515.555 515.555"
    >
      <path d="m496.679 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" />
      <path d="m303.347 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" />
      <path d="m110.014 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" />
    </svg>
  );
}

export { MenuIcon };
